var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "d-lg-none mb-3 text-end" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary btn-sm",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.mobileOpen = true
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-filter" }),
          _vm._v(" "),
          _vm.selectedTagIds.length
            ? _c("span", { staticClass: "badge bg-primary ms-1" }, [
                _vm._v(_vm._s(_vm.selectedTagIds.length)),
              ])
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "offcanvas offcanvas-end",
        class: { show: _vm.mobileOpen },
        style: _vm.mobileOpen ? "visibility:visible;" : "visibility:hidden;",
        attrs: { tabindex: "-1" },
      },
      [
        _c("div", { staticClass: "offcanvas-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("button", {
            staticClass: "btn-close",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.mobileOpen = false
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "offcanvas-body tag-filters" },
          _vm._l(_vm.categorisedTagList, function (group) {
            return _c(
              "div",
              { key: group.category, staticClass: "mb-3" },
              [
                _c("p", { staticClass: "fw-semibold small text-muted mb-1" }, [
                  _vm._v(_vm._s(group.category)),
                ]),
                _vm._v(" "),
                _vm._l(group.tags, function (tag) {
                  return _c(
                    "div",
                    { key: tag.id, staticClass: "form-check mb-3" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedTagIds,
                            expression: "selectedTagIds",
                          },
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          type: "checkbox",
                          id: `tag-offcanvas-${tag.id}`,
                        },
                        domProps: {
                          value: tag.id,
                          checked: Array.isArray(_vm.selectedTagIds)
                            ? _vm._i(_vm.selectedTagIds, tag.id) > -1
                            : _vm.selectedTagIds,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.selectedTagIds,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = tag.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.selectedTagIds = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.selectedTagIds = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.selectedTagIds = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "form-check-label d-flex justify-content-between align-items-center",
                          attrs: { for: `tag-offcanvas-${tag.id}` },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(tag.name))]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "badge bg-secondary bg-opacity-25 text-dark ms-2",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    tag.courses_published
                                      ? tag.courses_published.length
                                      : 0
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _vm.mobileOpen
      ? _c("div", {
          staticClass: "offcanvas-backdrop fade show d-lg-none",
          on: {
            click: function ($event) {
              _vm.mobileOpen = false
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row g-5" }, [
      _c(
        "div",
        { staticClass: "col-3 d-none d-lg-block border-end tag-filters" },
        _vm._l(_vm.categorisedTagList, function (group) {
          return _c("div", { key: group.category, staticClass: "mb-4" }, [
            _c("p", { staticClass: "fw-semibold mb-2" }, [
              _vm._v(_vm._s(group.category)),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "list-unstyled" },
              _vm._l(group.tags, function (tag) {
                return _c("li", { key: tag.id, staticClass: "mb-2" }, [
                  _c("div", { staticClass: "form-check small" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedTagIds,
                          expression: "selectedTagIds",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: `tag-${tag.id}` },
                      domProps: {
                        value: tag.id,
                        checked: Array.isArray(_vm.selectedTagIds)
                          ? _vm._i(_vm.selectedTagIds, tag.id) > -1
                          : _vm.selectedTagIds,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedTagIds,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = tag.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedTagIds = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedTagIds = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedTagIds = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "form-check-label d-flex justify-content-between align-items-center",
                        attrs: { for: `tag-${tag.id}` },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(tag.name))]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "badge bg-secondary bg-opacity-10 text-dark ms-2",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  tag.courses_published
                                    ? tag.courses_published.length
                                    : 0
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-9" }, [
        _c(
          "div",
          { staticClass: "row row-cols-1 row-cols-lg-3 g-3" },
          _vm._l(_vm.filteredProducts, function (product) {
            return _c(
              "div",
              {
                key: product.id,
                staticClass: "col my-3 course user-select-none",
              },
              [
                _vm.displayAsCard
                  ? [
                      _c(
                        "div",
                        { staticClass: "card border-0 rounded-3 h-100" },
                        [
                          !_vm.hasButtons
                            ? _c("a", {
                                staticClass: "stretched-link",
                                attrs: {
                                  href: `/${product.slug}`,
                                  "aria-label": product.title,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          product.cover_photo
                            ? _c("img", {
                                staticClass: "card-image-top rounded-top-3",
                                attrs: {
                                  src: product.cover_photo,
                                  alt: product.title,
                                  loading: "lazy",
                                },
                              })
                            : _c("img", {
                                staticClass: "card-image-top rounded-top-3",
                                attrs: {
                                  src: "https://placehold.co/1280x800/E1D4F1/ffffff",
                                  alt: "",
                                  loading: "lazy",
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "card-title text-black fw-bold small",
                                },
                                [_vm._v(_vm._s(product.title))]
                              ),
                              _vm._v(" "),
                              product.description
                                ? _vm._l(
                                    product.description.split("\n"),
                                    function (line, i) {
                                      return _c(
                                        "p",
                                        {
                                          key: i,
                                          staticClass: "card-text small",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(line) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              product.difficulty
                                ? _c("p", { staticClass: "card-text small" }, [
                                    _vm._v(_vm._s(product.difficulty)),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.doNotDisplayPrices
                                ? _c(
                                    "div",
                                    [
                                      product.is_free &&
                                      !product.allow_student_to_set_price
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-black free fw-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")("Free")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : product.is_free &&
                                          product.allow_student_to_set_price
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "text-black" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Set your price"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : !product.is_free &&
                                          product.allow_student_to_set_price
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-black fw-bold",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("translate")(
                                                        "From"
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        product.current_price
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                    |\n                    "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "text-black" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Set your price"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : product.price_variants
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-black fw-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Price variants"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : product.current_price
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-black fw-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      product.current_price
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            product.has_promo
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-muted ms-1",
                                                  },
                                                  [
                                                    _c("del", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatCurrency(
                                                            product.price
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasButtons
                                ? _c(
                                    "div",
                                    { staticClass: "text-center mb-3 mt-3" },
                                    [
                                      _vm.displayMoreButton
                                        ? _c(
                                            "a",
                                            {
                                              class: [
                                                "btn",
                                                "btn-" + _vm.moreButtonStyle,
                                              ],
                                              attrs: {
                                                href: `/${product.slug}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      _vm.moreButtonText
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.displayBuyButton
                                        ? _c(
                                            "a",
                                            {
                                              class: [
                                                "btn",
                                                "btn-" + _vm.buyButtonStyle,
                                              ],
                                              attrs: {
                                                href: `/${product.slug}/checkout`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      _vm.buyButtonText
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "course-hover-shadow position-relative rounded h-100",
                        },
                        [
                          !_vm.hasButtons
                            ? _c("a", {
                                staticClass: "stretched-link",
                                attrs: {
                                  href: `/${product.slug}`,
                                  "aria-label": product.title,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-fluid rounded mb-3",
                            attrs: {
                              src: _vm.imgUrl(product.cover_photo),
                              alt: product.title,
                              width: "1280",
                              height: "800",
                              loading: "lazy",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "h6",
                                { staticClass: "text-black mb-1 small" },
                                [_vm._v(_vm._s(product.title))]
                              ),
                              _vm._v(" "),
                              product.description
                                ? _vm._l(
                                    product.description.split("\n"),
                                    function (line, i) {
                                      return _c(
                                        "p",
                                        {
                                          key: i,
                                          staticClass: "text-muted mb-1 small",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(line) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", [
                            product.difficulty
                              ? _c("div", { staticClass: "text-muted small" }, [
                                  _vm._v(_vm._s(product.difficulty)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.doNotDisplayPrices
                              ? _c(
                                  "div",
                                  [
                                    product.is_free &&
                                    !product.allow_student_to_set_price
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "text-black free" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")("Free")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : product.is_free &&
                                        product.allow_student_to_set_price
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "text-black" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "Set your price"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : !product.is_free &&
                                        product.allow_student_to_set_price
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "text-black" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("translate")("From")
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      product.current_price
                                                    )
                                                  ) +
                                                  " |\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-black" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "Set your price"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : product.price_variants
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "text-black" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    "Price variants"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : product.current_price
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "text-black" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatCurrency(
                                                    product.current_price
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          product.has_promo
                                            ? _c(
                                                "small",
                                                { staticClass: "text-muted" },
                                                [
                                                  _c("del", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatCurrency(
                                                          product.price
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasButtons
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-center mt-3 position-relative",
                                    staticStyle: { "z-index": "2" },
                                  },
                                  [
                                    _vm.displayMoreButton
                                      ? _c(
                                          "a",
                                          {
                                            class: [
                                              "btn",
                                              "btn-" + _vm.moreButtonStyle,
                                            ],
                                            attrs: { href: `/${product.slug}` },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    _vm.moreButtonText
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.displayBuyButton
                                      ? _c(
                                          "a",
                                          {
                                            class: [
                                              "btn",
                                              "btn-" + _vm.buyButtonStyle,
                                            ],
                                            attrs: {
                                              href: `/${product.slug}/checkout`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("translate")(
                                                    _vm.buyButtonText
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ],
              ],
              2
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", { staticClass: "offcanvas-title text-secondary" }, [
      _c("i", { staticClass: "fas fa-filter" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }